import { Http } from '@gamiphy/http';
import { Purchase } from '@gamiphy/bl/purchases';

export class PurchasesApi {
  public static async createPurchase(purchase: Omit<Purchase, 'id' | 'app' | 'currency' | 'createdAt'>): Promise<Purchase> {
    const response = await Http.post<CreatePurchaseResponse>({
      url: '/v2/purchases',
      payload: purchase,
    });
    return response.data.purchase;
  }

  public static async getPurchases(): Promise<Purchase | undefined> {
    try {
      const response = await Http.get<GetPurchasesResponse>({
        url: '/v2/purchases',
      });
      return response.data.purchase;
    } catch {
      return undefined;
    }
  }

  public static async updatePurchase(id: string, data: Partial<Purchase>): Promise<Purchase> {
    const response = await Http.patch<UpdatePurchasesResponse>({
      url: `/v2/purchases/${id}`,
      payload: data,
    });
    return response.data.purchase;
  }
}

export type CreatePurchaseResponse = {
  purchase: Purchase,
}
export type GetPurchasesResponse = {
  purchase: Purchase,
}
export type UpdatePurchasesResponse = {
  purchase: Purchase
}
